module.exports = __webpack_public_path__ + "Gotham-Black.13edf6d74273d41a6ec1.svg";


//////////////////
// WEBPACK FOOTER
// /Users/vijay/projects/customers-app/src/assets/fonts/gotham/Gotham-Black.svg
// module id = ../../../../../src/assets/fonts/gotham/Gotham-Black.svg
// module chunks = styles